/**
 * JT Assets services
 *
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Category of asset
 */
export const Category = {
    Property: 'PROPERTY',
    Jewels: 'JEWELS',
    Car: 'CAR',
    Gemstone: 'GEMSTONE',
    Alcohol: 'ALCOHOL',
    Instrument: 'INSTRUMENT',
    Coin: 'COIN',
    Banknote: 'BANKNOTE',
    Art: 'ART',
    Loan: 'LOAN',
    Shares: 'SHARES',
    Other: 'OTHER'
} as const;
export type Category = typeof Category[keyof typeof Category];

